import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector     : 'empty-layout',
    templateUrl  : './empty.component.html',
    styleUrls    : ['./empty.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class EmptyLayoutComponent implements OnInit, OnDestroy
{
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(@Inject(DOCUMENT) private _document: Document)
    {
    }

    ngOnInit(): void
    {
        this._document.documentElement.classList.add('auth-document-scroll');
    }

    ngOnDestroy(): void
    {
        this._document.documentElement.classList.remove('auth-document-scroll');
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
